import { message } from "antd";

export const handleErrorsInDifferentKey = (error) => {
    if (error && error.data) {
      if (Array.isArray(error.data)) {
        error.data.forEach(msg => {
          message.error(msg);
        });
      } else if (typeof error.data === 'object') {
        Object.keys(error.data).forEach(key => {
          const value = error.data[key];
          if (Array.isArray(value)) {
            value.forEach(msg => {
              message.error(` ${msg}`);
            });
          } else if (typeof value === 'string') {
            message.error(`${value}`);
          } else if (typeof value === 'object') {
            Object.keys(value).forEach(nestedKey => {
              message.error(`${value[nestedKey]}`);
            });
          }
        });
      } else {
        message.error('Unknown error format');
      }
    } else {
      message.error('No error data available');
    }
  };


export function extractErrorMessages(errorData, parentKey = '') {
  let messages = [];
  if(!errorData) return null
  if (Array.isArray(errorData)) {
    // Handle array of strings or nested arrays/objects
    errorData.forEach((item) => {
      messages.push(...extractErrorMessages(item, parentKey));
    });

  } else if (typeof errorData === 'object' && errorData !== null) {
    // Handle nested objects
    Object.keys(errorData).forEach((key) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      messages.push(...extractErrorMessages(errorData[key], fullKey));
    });

  } else if (typeof errorData === 'string') {
    // Base case: simple string message
    messages.push(`${parentKey ? `${parentKey}: ` : ''}${errorData}`);
  }

  return messages;
}
